import { getVersion } from '../../../releases';
import { Typography } from '../typography/typography';
import { navMenuFooter } from './navMenu.css';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons';

export type NavMenuFooterProps = {
  onLogout: () => void;
};

export const NavMenuFooter = (p: NavMenuFooterProps) => {
  const isTablet = useBreakpoints((s) => s.tablet);

  return (
    <footer className={navMenuFooter}>
      {isTablet ? (
        <div role="button" onClick={p.onLogout}>
          <FontAwesomeIcon icon={faArrowRightFromBracket} color="inherit" />
        </div>
      ) : (
        <>
          <div role="button" onClick={p.onLogout}>
            <Typography variant="body" size="medium" as="span" color="N-60">
              Log out
            </Typography>
          </div>
          <Typography variant="body" size="small" as="span">
            Version {getVersion()}
          </Typography>
        </>
      )}
    </footer>
  );
};
